import { useQuery } from '@tanstack/react-query';
import type { UseQueryOptions } from '@tanstack/react-query';
import type { IProduct } from 'v2/interfaces/product';
import productService from 'v2/services/product';

function useProductVariations(parentId: number, options?: Omit<UseQueryOptions<IProduct[]>, 'queryKey' | 'queryFn'>) {
  return useQuery<IProduct[]>({
    queryKey: ['product', parentId, 'variations'],
    queryFn: () => productService.getProductVariations(parentId),
    ...options
  });
}

export { useProductVariations };
